var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-manage-wrap"},[_c('coal-shed-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }